import {ApiError, ApiService} from "@/services/api.service";
import {Constants} from "@/constants";
import XLSX from "xlsx";
import moment from "moment";
import {TimezoneService} from "@/services/timezone.service";
import {BookingService} from "@/services/booking.service";

const BookingExport = {


    exportBookingsToExcel: async function (location, startDateString, endDateString) {
        try {
            let bookings = await BookingService.getBookingsByLocation(location, startDateString, endDateString, false)
            // convert bookings  to correct timezone
            bookings = TimezoneService.correctAllBookingsDown(bookings, location)
            const formatted = this.formatJSONBookingToExcel(bookings)
            const excel = XLSX.utils.json_to_sheet(formatted);

            const wb = XLSX.utils.book_new();
            // Add the excel sheet to the excel file, name the sheet "bookings"
            XLSX.utils.book_append_sheet(wb, excel, "bookings");
            // Download the excel file
            XLSX.writeFile(wb, "Bookings.xlsx");
        } catch (error) {
            //await this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: "404", message: "no bookings found"})
            throw new ApiError(error)
        }
    },
    formatJSONBookingToExcel: function(bookings) {
        bookings = bookings.filter(b => b.status.id !== '3')
        let resultArray = []
        for (let booking of bookings) {
            let bookingFormatted = {
                ID: booking.id,
                Customer: booking.customer.name,
                Entity: booking.entity.name,
                Location: booking.location.name,
                Spots: "",
                "Start date": moment(booking.entity.startDate).format('YYYY-MM-DD HH:mm') ,
                "End date": moment(booking.entity.endDate).format('YYYY-MM-DD HH:mm'),
                "Arrival date": "",
                "Departure date": "",
                "On Dock": "",
                "Off Dock": "",
                "Start Handling": "",
                "Stop Handling": "",
                "Created by": booking.userCreated,
                "License plate": booking.licensePlate
            }
            if(booking.vehicleArrivalDate){
                bookingFormatted["Arrival date"] = moment(booking.vehicleArrivalDate).format('YYYY-MM-DD HH:mm')
            }
            if(booking.vehicleDepartureDate){
                bookingFormatted["Departure date"] = moment(booking.vehicleDepartureDate).format('YYYY-MM-DD HH:mm')
            }

            if(booking.dockArrivalDate){
                bookingFormatted["On Dock"] = moment(booking.dockArrivalDate).format('YYYY-MM-DD HH:mm')
            }
            if(booking.dockDepartureDate){
                bookingFormatted["Off Dock"] = moment(booking.dockDepartureDate).format('YYYY-MM-DD HH:mm')
            }

            if(booking.startHandlingDate){
                bookingFormatted["Start Handling"] = moment(booking.startHandlingDate).format('YYYY-MM-DD HH:mm')
            }
            if(booking.stopHandlingDate){
                bookingFormatted["Stop Handling"] = moment(booking.stopHandlingDate).format('YYYY-MM-DD HH:mm')
            }

            // Append the spots
            let spotString = ""
            for (let spot of booking.spots) {
                spotString += spot.label + ", "
            }
            // Remove the last ,
            bookingFormatted.Spots = spotString.substring(0, spotString.length - 2)

            // Append the booking options.
            for (let bookingOption of booking.options) {
                bookingFormatted[`${bookingOption.name}`] = bookingOption.value
            }
            resultArray.push(bookingFormatted)
        }
        return resultArray
    }
}

export { BookingExport }
